import Backbone from 'backbone'
import _ from 'lodash'
import TweenMax, { TimelineMax, Power3, Expo  } from 'gsap'
import template from './scanning-icon.hbs'

var ScanningIcon = Backbone.View.extend({
	className: 'scanning-icon-container',

	render: function() {
		this.id = _.uniqueId('dataset_processing_icon_')
		this.$el.append(template({id: this.id}))
		return this
	},

	init: function() {
		TweenMax.set(this.$('.scanning-icon-' + this.id), {
			visibility: 'visible'
		})

		TweenMax.set('.iconGroup-' + this.id, {
			transformOrigin:'50% 50%'
		})

		this.mainTl = new TimelineMax({}).timeScale(1)
		this.blockTl = new TimelineMax({}).timeScale(1)
		this.iconTl = new TimelineMax({repeat:-1, repeatDelay:2}).timeScale(2)
		var layoutDistance = 20

		this.iconTl.to('.scanning-icon-' + this.id + ' .iconGroup', 1, {
			skewY:22,
			scale:0.86,
			ease: Power3.easeInOut
		})
		.staggerTo('.scanning-icon-' + this.id + ' .iconGroup', 1, {
			cycle:{
				x:[ 10, 0, -10],
				y:[ -3, 0,3 ]
			},
			ease: Power3.easeInOut
		},0,'-=1')
		.staggerTo('.scanning-icon-' + this.id + ' .iconGroup', 0.6, {
			cycle:{
				alpha:[0.1,0.3,1]
			},
			ease: Expo.easeOut
		},0, '-=1')
		.from('.scanning-icon-' + this.id + ' .layout2', 1, {
			attr:{
				x:'-=' + layoutDistance
			},
			ease: Power3.easeInOut
		},'-=1')
		.to('.scanning-icon-' + this.id + ' .layout1', 1, {
			attr:{
				x:'+=' + layoutDistance
			},
			ease: Power3.easeInOut
		},'-=1')
		.from('.scanning-icon-' + this.id + ' .layout3', 1, {
			attr:{
				y:'-=' + layoutDistance
			},
			ease: Power3.easeInOut
		})
		.to('.scanning-icon-' + this.id + ' .layout2', 1, {
			attr:{
				y:'+=' + layoutDistance
			},
			ease: Power3.easeInOut
		},'-=1')
		.from('.scanning-icon-' + this.id + ' .layout4', 1, {
			attr:{
				x:'-=' + layoutDistance
			},
			ease: Power3.easeInOut
		})
		.to('.scanning-icon-' + this.id + ' .layout3', 1, {
			attr:{
				x:'+=' + layoutDistance
			},
			ease: Power3.easeInOut
		},'-=1')
		.from('.scanning-icon-' + this.id + ' .layout5', 1, {
			attr:{
				y:'-=' + layoutDistance
			},
			ease: Power3.easeInOut
		})
		.to('.scanning-icon-' + this.id + ' .layout4', 1, {
			attr:{
				y:'+=' + layoutDistance
			},
			ease: Power3.easeInOut
		},'-=1')
		.from('.scanning-icon-' + this.id + ' .layout6', 1, {
			attr:{
				x:'-=' + layoutDistance
			},
			ease: Power3.easeInOut
		})
		.to('.scanning-icon-' + this.id + ' .layout5', 1, {
			attr:{
				x:'+=' + layoutDistance
			},
			ease: Power3.easeInOut
		},'-=1')
		.from('.scanning-icon-' + this.id + ' .layout7', 1, {
			attr:{
				y:'-=' + layoutDistance
			},
			ease: Power3.easeInOut
		})
		.to('.scanning-icon-' + this.id + ' .layout6', 1, {
			attr:{
				y:'+=' + layoutDistance
			},
			ease: Power3.easeInOut
		},'-=1')
		.set('.scanning-icon-' + this.id + ' .offscreenLayout', {
			autoAlpha:0
		})
		.set('.scanning-icon-' + this.id + ' .initLayout' , {
			attr:{
				y:0,
				x:0
			}
		})
		.staggerTo('.scanning-icon-' + this.id + ' .iconGroup', 1, {
			cycle:{
				x:[ 0, 0, -0],
				y:[ 0, 0,0 ]
			},
			ease: Power3.easeInOut
		}, 0, '-=1')
		.staggerTo('.scanning-icon-' + this.id + ' .iconGroup', 0.6, {
			cycle:{
				alpha:[0,0,1]
			},
			ease: Power3.easeIn
		},0, '-=1')
		.to('.scanning-icon-' + this.id + ' .iconGroup', 1, {
			skewY:0,
			scale:1,
			ease: Power3.easeInOut
		},'-=1')

		this.mainTl.add(this.iconTl)
	},

	pause: function(time) {
		this.mainTl?.pause(time)
		this.iconTl?.pause(time)
		this.blockTl?.pause(time)
	},

	restart: function() {
		this.mainTl?.restart()
		this.iconTl?.restart()
		this.blockTl?.restart()
	}
})

export default ScanningIcon

ScanningIcon.__filename__ = 'components/scanning-icon.js'
